import { DeepPartial } from 'core';
import { FullWidthButtonGroup, Modal } from 'ui';

import { AddToCartButton, AddToCartButtonProps } from '../AddToCartButton/AddToCartButton';
import { BuyNowButton, BuyNowButtonProps } from '../BuyNowButton/BuyNowButton';
import { SharedCheckoutButtonsProps } from './CheckoutButtons.types';

interface CheckoutButtonsProps extends SharedCheckoutButtonsProps {
  addToCartProps?: DeepPartial<Omit<AddToCartButtonProps, 'onCartCreate'>>;
  buyNowProps?: DeepPartial<Omit<BuyNowButtonProps, 'onCartCreate'>>;
  addToCartVisible?: boolean;
  buyNowVisible?: boolean;
}

const CheckoutButtons = ({
  storeId,
  storeItemId,
  quantity,
  cartItems,
  addToCartProps,
  buyNowProps,
  validateOnClick,
  addToCartVisible = true,
  buyNowVisible = true,
  onOptions,
  onCartCreate,
  cartFields,
}: CheckoutButtonsProps) => {
  return (
    <Modal.AffixedFooter>
      <FullWidthButtonGroup>
        {addToCartVisible && (
          <AddToCartButton
            storeId={storeId}
            storeItemId={storeItemId}
            cartItems={cartItems}
            quantity={quantity}
            onOptions={onOptions}
            validateOnClick={validateOnClick}
            onCartCreate={onCartCreate}
            cartFields={cartFields}
            {...addToCartProps}
          />
        )}
        {buyNowVisible && (
          <BuyNowButton
            storeId={storeId}
            storeItemId={storeItemId}
            cartItems={cartItems}
            quantity={quantity}
            onOptions={onOptions}
            onCartCreate={onCartCreate}
            validateOnClick={validateOnClick}
            cartFields={cartFields}
            {...buyNowProps}
          />
        )}
      </FullWidthButtonGroup>
    </Modal.AffixedFooter>
  );
};

export { CheckoutButtons };
export type { CheckoutButtonsProps };
